import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from '@mui/material';

import { useTranslations } from 'context/TranslationContext';

import { modal } from 'styles/components/ModalStyle';
import {
  discardButtonStyle,
  unsavedChangesDialogActions,
  unsavedChangesDialogContent,
  unsavedChangesDialogTitle
} from 'styles/components/UnsavedChangesModalStyle';

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onContinueEditing: () => void;
  onDiscard: () => void;
}

export const UnsavedChangesModal = ({
  isOpen,
  onContinueEditing,
  onDiscard
}: UnsavedChangesModalProps) => {
  const { translate } = useTranslations();

  return (
    <Dialog open={isOpen} sx={modal} maxWidth="sm">
      <DialogTitle sx={unsavedChangesDialogTitle}>
        {translate('unsavedChanges.title')}
      </DialogTitle>
      <DialogContent sx={unsavedChangesDialogContent}>
        {translate('unsavedChanges.description')}
      </DialogContent>
      <DialogActions sx={unsavedChangesDialogActions}>
        <Button variant="outlined" onClick={onContinueEditing}>
          {translate('unsavedChanges.continueEditing')}
        </Button>
        <Button
          variant="contained"
          color="error"
          sx={discardButtonStyle}
          onClick={onDiscard}
        >
          {translate('unsavedChanges.discard')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
